<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH-1"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="FMTNI">With grateful thanks to Jessica McCarthy and Philippa Makepeace, who brought Devon to life for me. Also to my editors—Maxine Hitchcock at Simon &amp; Schuster in London and Jennifer Weis at St. Martin’s Press in New York—for their invaluable insights and advice.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?319be301